import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Template } from '../../../interfaces/template.interface';
import { GetTemplatesParams, GetTemplatesResponse } from '../interfaces/get-templates';
import { RequestError } from '../../../interfaces/error.interface';

export interface TemplateState {
  templates: Template[];
  template: Template | null;
  options: GetTemplatesParams;
  errorCode: number | null;
}

const initialState: TemplateState = {
  templates: [],
  options: { text: '' },
  template: null,
  errorCode: null,
};

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    getTemplatesInitApiAction: (state) => {
      state.errorCode = null;
    },
    getTemplatesSuccessApiAction: (state, action: PayloadAction<GetTemplatesResponse>) => {
      state.templates = action.payload.templates;
    },
    getTemplatesFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postTemplateInitApiAction: () => {},
    postTemplateSuccessApiAction: () => {},
    postTemplateFailuireApiAction: () => {},
    putTemplateInitApiAction: () => {},
    putTemplateSuccessApiAction: () => {},
    putTemplateFailuireApiAction: () => {},
    setTemplateAction: (state, action: PayloadAction<Template>) => {
      state.template = action.payload;
    },
    setOptionsAction: (state, action: PayloadAction<GetTemplatesParams>) => {
      state.options = action.payload;
    },
    resetOptionsAction: (state) => {
      state.options = { text: '' };
    },
    templateClearAction: (state) => {
      state.templates = [];
      state.template = null;
    },
  },
});

export const {
  getTemplatesInitApiAction,
  getTemplatesSuccessApiAction,
  getTemplatesFailureApiAction,
  postTemplateInitApiAction,
  postTemplateSuccessApiAction,
  postTemplateFailuireApiAction,
  putTemplateInitApiAction,
  putTemplateSuccessApiAction,
  putTemplateFailuireApiAction,
  setTemplateAction,
  setOptionsAction,
  resetOptionsAction,
  templateClearAction,
} = templateSlice.actions;

export default templateSlice.reducer;
